import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';
import { DashboardComponent } from './dashboard.component';
import { ChartExpandableCardComponent } from './chart-expandable-card/chart-expandable-card.component';
import { ChartFullscreenDialogComponent } from './chart-fullscreen-dialog/chart-fullscreen-dialog.component';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ChartExpandableCardComponent,
    ChartFullscreenDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatSelectModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    BaseChartDirective,
    PageHeaderComponent,
  ],
  exports: [DashboardComponent],
})
export class DashboardModule {}
